import React from 'react'
import { CategoryTag } from '../components/categoryTags'
import { SearchPreview } from '../components/searchPreview'
import { SearchResultRow } from '../components/searchResultRow'
import styles from '../styles.css'

type PropsType = {
  config: any
  colors: any
  sectionNumber: number
  setSection: (index: number) => void
  activeRowIndex: number
  setActiveRowIndex: (num: number) => void
  executeAction: (entry: any, cmdPressed: boolean) => void
  previewMode?: boolean
}

export const Categories = (props: PropsType) => {
  var config = props.config
  var sectionNumber = props.sectionNumber
  var setSection = props.setSection
  var activeRowIndex = props.activeRowIndex
  var setActiveRowIndex = props.setActiveRowIndex
  var executeAction = props.executeAction

  const activeEntry = config[Object.keys(config)[sectionNumber]][activeRowIndex]
  const showPreview =
    activeEntry?.preview !== undefined &&
    (activeEntry?.preview?.image || activeEntry?.data)

  return (
    <div>
      <div className={styles.navContainer}>
        {Object.keys(config).map((key: string, index: number) => {
          return (
            <CategoryTag
              key={key + index}
              colors={props.colors}
              renderKey={key}
              active={key === Object.keys(config)[sectionNumber]}
              setSection={setSection}
              index={index}
            />
          )
        })}
      </div>

      <div style={{ flexDirection: 'row', display: 'flex' }}>
        <div
          style={{
            marginTop: 20,
            maxHeight: '300px',
            overflow: 'hidden',
            width: !showPreview ? '100%' : '60%',
            paddingBottom: 16
          }}
        >
          {config[Object.keys(config)[sectionNumber]].map(
            (entry: any, index: number) => {
              const active = index === activeRowIndex
              const uuid = entry.uuid

              return (
                <SearchResultRow
                  active={active}
                  colors={props.colors}
                  setActiveRowIndex={setActiveRowIndex}
                  executeAction={executeAction}
                  index={index}
                  entry={entry}
                  key={uuid}
                  previewMode={props.previewMode}
                />
              )
            }
          )}
        </div>
        {showPreview && (
          <SearchPreview
            entry={activeEntry}
            executeAction={executeAction}
            colors={props.colors}
          />
        )}
      </div>
    </div>
  )
}
